import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { KnBrSupportComponent } from './kn-br-support.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        // TODO Replce the below component with the actual component name
        CwtSupportComponent: {
            component: KnBrSupportComponent,
        },
      },
  } as CmsConfig),
  ]
})
export class KnBrSupportModuleTsModule { }